import { useRef, useState } from 'react';
import methodModel from '../../methods/methods';
import './BookStyles.css'; // Optional external CSS for layout/animation
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import environment from '../../environment';

const BookOpenAnimation = ({ detail }) => {
    var right = document.getElementsByClassName("right");
    const si = useRef(right.length);
    var z = 1;
    const [currentIndex, setCurrentIndex] = useState(1);
    const [loader, setLoader] = useState(false);
    const urlPath = window.location.pathname

    const turnLeft = () => {
        setLoader(true)
        if (si.current < right.length) {
            si.current++;
        }
        else {
            si.current = 1;
            for (var i = right.length - 1; i > 0; i--) {
                right[i].classList.add("flip");
                right[i].style.zIndex = right.length + 1 - i;
            }
        }
        right[si.current - 1].className = "right";
        setTimeout(function () { right[si.current - 1].style.zIndex = "auto"; }, 350);
        setCurrentIndex(currentIndex - 1);
        setTimeout(() => {
            setLoader(false)
        }, 1000);
    };

    const turnRight = () => {
        setLoader(true)
        if (si.current >= 1) {
            si.current--;
        }
        else {
            si.current = right.length - 1;
            function sttmot(i) {
                setTimeout(function () { right[i].style.zIndex = "auto"; }, 300);
            }
            for (var i = 0; i < right.length; i++) {
                right[i].className = "right";
                sttmot(i);
                z = 1;
            }
        }
        right[si.current].classList.add("flip");
        z++;
        right[si.current].style.zIndex = currentIndex === 2 ? "5" : z;
        setCurrentIndex(currentIndex + 1);
        setTimeout(() => {
            setLoader(false)
        }, 1000);
    };

    const rightPosition = currentIndex === 1 ? "170px" : currentIndex === 3 ? "-170px" : "0";

    const waterMark = () => {
        if (urlPath === "/checkout") {
            return <div className="absolute inset-0 pointer-events-none grid grid-cols-4 grid-rows-4 gap-4" style={{ opacity: 0.1 }}>
                {Array(16).fill(0).map((_, i) => (
                    <span key={i} className="text-primary text-2xl font-bold select-none transform -rotate-45 flex items-center justify-center">
                        FRUM ME 2 U
                    </span>
                ))}
            </div>
        } else {
            return ""
        }
    }

    return (
        <>
            <div className="new-section card_figure">
                <div className="book-section">
                    <div className="container relative mobilescale">
                        <div className="right" style={{ right: rightPosition }}>
                            <figure
                                className="back !bg-white"
                                id="back-cover"
                                style={{ backgroundImage: `url(${methodModel.noImg(detail?.cartDetail?.capturedImages?.[3])})` }}
                            >
                                {/* <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                    <div className="relative w-52 h-52 ">
                                        <img
                                            src="../assets/img/black_heart.png"
                                            alt="Heart"
                                            className="w-full h-full object-contain"
                                        />
                                        <p className="absolute inset-0 flex items-center justify-center -top-3 text-black text-center text-sm font-semibold py-4 px-6">
                                            Touching One Heart At A Time
                                        </p>
                                    </div>
                                </div>
                                <div className="absolute bottom-3 right-4 transform  text-white text-sm text-right  px-2">
                                    <p className="text-md font-semibold text-gray-900">FRUM ME 2 U</p>
                                    <p className="text-[12px] font-medium text-gray-800">{environment.frontendUrl}</p>
                                </div> */}
                            </figure>
                            <figure
                                className="front !bg-[#fef6e9]"
                                style={{ backgroundImage: `url(${methodModel.noImg(detail?.cartDetail?.capturedImages?.[2])})` }}
                            >
                                {waterMark()}
                            </figure>
                        </div>
                        <div className="right" style={{ right: rightPosition }}>
                            <figure
                                className="back !bg-[#fef6e9]"
                                style={{ backgroundImage: `url(${methodModel.noImg(detail?.cartDetail?.capturedImages?.[1])})` }}
                            >
                                {waterMark()}
                            </figure>
                            <figure
                                className="front !bg-[#fef6e9]"
                                id="cover"
                                style={{ backgroundImage: `url(${methodModel.noImg(detail?.cartDetail?.capturedImages?.[0])})` }}
                            >
                            </figure>
                        </div>
                    </div>

                    {/* Navigation Buttons */}
                    <div className="flex gap-2 items-center justify-center">
                        <button
                            type="button"
                            onClick={turnLeft}
                            disabled={loader || currentIndex === 1}
                            className="disabled:cursor-not-allowed h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200"
                        >
                            <FaArrowLeft />
                        </button>
                        {/* Progress Bar */}
                        <div className="w-32 lg:w-96 bg-gray-200 rounded-full h-2.5 my-4">
                            <div
                                className="bg-primary h-2.5 rounded-full transition-all duration-300"
                                style={{ width: `${(currentIndex - 1) * 50}%` }}
                            />
                        </div>
                        <button
                            type="button"
                            onClick={turnRight}
                            disabled={loader || currentIndex === 3}
                            className="disabled:cursor-not-allowed h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200"
                        >
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
            </div>

        </>
    );
};

export default BookOpenAnimation;